// Hues ordered by bisection: each new entry splits the largest remaining
// gap on the colour wheel, so any first-N prefix is maximally spread.
// First 8 are 45° apart; 9–14 halve the remaining 22.5° gaps.
export const TYPE_HUES = [0, 180, 90, 270, 45, 135, 225, 315, 22, 112, 202, 292, 67, 157];

export const typeHue = (typeId) => TYPE_HUES[(typeId ?? 0) % TYPE_HUES.length];

// Pill badge: pastel tint derived from the type’s hue.
export const roadblockTypePillStyle = (typeId) => {
    const hue = typeHue(typeId);
    return {
        display: 'inline-block',
        padding: '0.2em 0.55em',
        borderRadius: '0.25rem',
        fontSize: '0.78rem',
        fontWeight: '600',
        whiteSpace: 'nowrap',
        background: `hsl(${hue}, 55%, 88%)`,
        color: `hsl(${hue}, 55%, 28%)`,
    };
};

// Roles that can be assigned to any team's roadblock.
const ASSIGNABLE_CROSS_TEAM_ROLES = new Set(['associate manager', 'manager']);
// Roles that can only be assigned if they're a member of the roadblock's team.
const ASSIGNABLE_TEAM_ROLES = new Set(['associate', 'senior']);

/**
 * Returns Semantic UI dropdown options for members eligible to be assigned
 * to a roadblock belonging to `teamId`.
 *
 * - Associates/Seniors: only eligible if on the roadblock's team.
 * - Associate Managers/Managers: eligible regardless of team.
 * - All other roles (Director, VP, Maintenance, etc.): not eligible.
 */
export function getEligibleMemberOptions(allMembers, teamId) {
    return allMembers
        .filter(m => {
            const role = m.role?.toLowerCase() ?? '';
            if (ASSIGNABLE_CROSS_TEAM_ROLES.has(role)) return true;
            if (ASSIGNABLE_TEAM_ROLES.has(role)) return teamId != null && teamId !== '' && m.teamIds?.includes(teamId);
            return false;
        })
        .map(m => ({ key: m.userId, value: m.userId, text: m.name }));
}

export const TIME_UNIT_OPTIONS = [
    { key: 'hours',  value: 'hours',  text: 'Hours' },
    { key: 'days',   value: 'days',   text: 'Days' },
    { key: 'weeks',  value: 'weeks',  text: 'Weeks' },
    { key: 'months', value: 'months', text: 'Months' },
];
